import Route from 'rise-ui/utils/routing/route.js';

import { service } from '@ember/service';
import { hash } from 'rsvp';

import { breadcrumb, breadcrumbResolve, breadcrumbResolved } from 'rise-ui/services/breadcrumb.js';
import { scrollRoot } from 'rise-ui/services/scroll-root.js';

@scrollRoot
export default class CatalogRecordRoute extends Route {
  @service store;

  @breadcrumb crumb = 'Catalog Record';

  model({ catalog_record_id }) {
    const filterForCurrentRecord = (getId = r => r) =>
      records => records.filter(record => getId(record) !== catalog_record_id);

    // Fetch the catalog record by ID
    const record = this.store.findRecord('catalog-record', catalog_record_id, {
      include: 'catalogItems,location',
      backgroundReload: true
    });

    // Fetch catalog records with the same generation-effort
    const otherRecordsForGenerationEffort = record
      .then(({ generationEffortId }) => {
        if (this.store.isDestroyed) {
          return Promise.reject();
        }
        return !generationEffortId ? [] : this.store.queryWithCache(
          'records-with-generation-effort',
          'catalog-record',
          {
            generationEffortId: generationEffortId,
            'order[updateDate]': 'DESC',
            'order[recordTitle]': 'ASC',
            hasItemStructure: true,
          }
        )
      })
      .then(filterForCurrentRecord(r => r.get('id')));

    const location = record.then(({ location }) => location);

    // Fetch catalog records with the same location
    const otherRecordsForLocation = location
      .then(location => filterForCurrentRecord()(location.hasMany('catalogRecords').ids()))
      .then(ids => {
        return !ids.length ? [] : this.store.queryWithCache(
          'other-records-for-location',
          'catalog-record',
          { hasItemStructure: true, id: ids.join(',') }
        )
      });

    return hash({
      record,
      otherRecordsForGenerationEffort,
      otherRecordsForLocation,
      location,
      relatedLocations: location.then(({ relatedLocations }) => relatedLocations)
        .catch(() => {}),
    });
  }

  @breadcrumbResolve crumbResolve(model) {
    return model.record;
  }
  @breadcrumbResolved modelCrumb(model) {
    return model.record.get('title');
  }
}
